import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResRedirectConsent } from './auth.service.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  private authApi = `${environment.backendUrl}/login`;

  login(
    username: string,
    password: string,
    recaptchaToken: string
  ): Observable<any> {
    const body = new URLSearchParams();
    body.set('username', username);
    body.set('password', password);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: recaptchaToken,
      }),
      responseType: 'text' as const,
      observe: 'response' as const,
    };

    return this.http.post(this.authApi, body, httpOptions);
  }

  redirectUrl(redirectUrl: string): Observable<ResRedirectConsent> {
    return this.http.get<ResRedirectConsent>(redirectUrl);
  }
}
